import React, { useEffect, useRef, useState } from "react";
import { ReactNewWindowStyles } from "react-new-window-styles";
import { getGroupId, getMainRoomRole } from "../../../base/conference";
import { checkCloseGroupPermission, checkGroupPermission } from "../../../base/participants";
import { connect } from "../../../base/redux";
import { LayoutGroup } from "../../../group";
import { setGroupPanel } from "../../../group/action";

function GroupDualMonitor({ dispatch, show,  panel }) {
    if (!show) return null;
    const newWindowNode = useRef();
    const [outerWidth, setOuterWidth] = useState(960);
    const [outerHeight, setOuterHeight] = useState(600);
    const [windowOpen, setWindowOpen] = useState(false);
    const [ isMobile, setIsMobile ] = useState(false);
    const [ scale, setScale ] = useState(1);

    const setContainerStyle = (e) => {
        const { innerWidth: fullWidth } = e.target;
        const { innerWidth, innerHeight } = e.target.document.defaultView;
        const { width: screenWidth, height: screenHight } = e.target.screen;

        const width = Math.min(innerWidth, screenWidth);
        const height = Math.min(innerHeight, screenHight);
        setScale(fullWidth / width || 1);
        
        setOuterWidth(width);
        setOuterHeight(height);

        const mobile = width < 650 ? true : false;

        setIsMobile(mobile);
    }

    const unload = () => {
        dispatch(setGroupPanel(false));
        setWindowOpen(false);
    }

    const open = e => {
        setContainerStyle(e);
        e.addEventListener("resize", setContainerStyle);
    }

    const handlerAlertMessage = (message) => {
        const element = newWindowNode.current.state.externalWindow;
        if (element && element.window) {
            element.window.alert(message)
        }
    }

    useEffect(() => {
        return () => {
            setWindowOpen(false);
        }
    }, []);

    useEffect(() => {
        if (panel) {
            setWindowOpen(true);
        }
    }, [panel]);

    useEffect(() => {
        if (windowOpen && newWindowNode) {
            const element = newWindowNode.current.state.externalWindow;
            if (element && element.window) {
                element.window.addEventListener('resize', setContainerStyle);
            }
        } 
    }, [windowOpen]);

    return (
        <>
            { panel && <ReactNewWindowStyles ref={newWindowNode} title="Meemate2-group"
                windowProps={{width: '960px', height: '600px'}} 
                onClose={unload}
                resizable={true}
                copyStyles={true}
                autoClose={true}>
                <div style={{
                    width: "100%", height: "100%", 
                    display: "flex", justifyContent: "center", alignItems: "center"
                }}>   
                    <LayoutGroup scale={scale} isMobile={isMobile} width={outerWidth} height={outerHeight} handlerAlertMessage={handlerAlertMessage} />
                </div>
            </ReactNewWindowStyles>}
        </>
    );
}

function _mapStateToProps(state) {
    const { panel } = state["features/group"];
    const mainRole = getMainRoomRole(state);
    const groupId = getGroupId(state);
    const show = checkCloseGroupPermission(mainRole) && groupId === "";
    
    return {
        panel, show
    }
}

export default connect(_mapStateToProps)(GroupDualMonitor);
